<template>
  <div>
    <el-dialog
      title="Select image"
      append-to-body
      class="images-dialog"
      width="80vw"
      :visible.sync="dialogFormVisible"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="Select" name="select">
          <select-tab @submit="submitImage" />
        </el-tab-pane>
        <el-tab-pane label="Upload" name="upload">
          <upload-tab ref="uploadTab" @submit="uploadImage" />
          <el-progress v-show="uploadProgress" :percentage="uploadProgress" />
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm()">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import UploadTab from './UploadTab'
import SelectTab from './SelectTab'
import { Image } from '@/api'

export default {
  components: {
    SelectTab,
    UploadTab
  },
  data() {
    return {
      activeName: 'select',
      dialogFormVisible: false,
      uploadProgress: 0
    }
  },
  methods: {
    uploadImage(image) {
      try {
        const payload = {}
        if (image.name.endsWith('.svg')) {
          payload['svg_file'] = image
        } else {
          payload['file'] = image
        }

        Image.save(payload, this.onUploadProgress)
          .then(response => {
            this.submitImage(response.data.id)
          })
          .catch(error => {
            this.uploadError(error)
          })
      } catch (e) {
        console.log('catch')
        console.log(e)
      }
    },
    onUploadProgress(progressEvent) {
      const progress = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      this.uploadProgress = parseInt(progress)
    },
    submitImage(image) {
      this.$emit('submit', image)
      this.dialogFormVisible = false
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },

    uploadError(error) {
      let message = 'An error occurred while uploading an image.'

      if (error.response.status == 413) {
        message = 'Uploaded image is too large.'
      }

      this.$refs.uploadTab.clear()

      this.$message({
        message: message,
        type: 'error'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.images-dialog {
  z-index: 775666 !important;
}
</style>
